module.exports = __webpack_public_path__ + "img/53640c4f19a47f26028248eb3d5411cb.svg";